// ABOUTME: Card component representing a single data source option in the selector grid.
// ABOUTME: Shows logo and source name. All sources look equally clickable.

export interface SourceCardProps {
  name: string;
  logoSrc: string;
  onClick: () => void;
  comingSoon?: boolean;
}

export function SourceCard({ name, logoSrc, onClick, comingSoon }: SourceCardProps) {
  return (
    <button
      onClick={onClick}
      className="relative flex flex-col items-center gap-3 p-6 rounded-sm border-2 border-surface-200 bg-surface-0 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer group text-center"
    >
      {comingSoon && (
        <span className="absolute top-2 right-2 text-[10px] font-medium px-2 py-0.5 rounded-full bg-surface-100 text-surface-500">
          Coming Soon
        </span>
      )}
      <img
        src={logoSrc}
        alt={name}
        className="w-16 h-16 object-contain"
      />
      <span className="text-sm font-semibold text-surface-900 group-hover:text-primary-700">
        {name}
      </span>
    </button>
  );
}
